import React, { useCallback } from "react"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import classNames from "classnames"
import SwatchSet from "components/Stacker/components/SwatchSet/SwatchSet"
import SelectButton from "../../Common/SelectButton/SelectButton"
import "./NecklaceChooserItem.scss"
import { useI18nContext } from "i18n/i18n-react"
import SlickArrow from "../../SlickArrow/SlickArrow"

function NecklaceChooserItem({
  baseProduct,
  selected,
  selectedVariant,
  swatchIndex,
  variants,
  onImageLoad,
  onClick,
}) {
  const { LL } = useI18nContext()
  const handleOnImageLoad = useCallback(() => {
    onImageLoad(baseProduct)
  }, [baseProduct, onImageLoad])

  const onSelectClick = useCallback(() => {
    const { rawTitle, thickness } = variants[swatchIndex]
    onClick(
      baseProduct,
      rawTitle.includes("Vehicle"),
      thickness ? parseFloat(thickness) : 0
    )
  }, [baseProduct, onClick, swatchIndex, variants])

  const { productImage, rawTitle } = variants[swatchIndex]

  const swatchSettings = {
    dots: false,
    infinite: true,
    accessibility: true,
    centerPadding: "-1px",
    centerMode: true,
    slidesToShow: variants.length < 3 ? variants.length : 3,
    slidesToScroll: 1,
    speed: 500,
    nextArrow: <SlickArrow iconName="icon-arrow-right" />,
    prevArrow: <SlickArrow iconName="icon-arrow-left" />,
  }

  const selectBtnClasses = classNames(
    { "d-none": !selected },
    "d-xl-inline-block"
  )

  // const finalImg = `${productImage}.jpg`
  // const finalImg = `${productImage}_STACKER_PREVIEW.png`
  const finalImg = `${productImage}_STACKER_PREVIEW${
    isMobile() ? "_MOBILE.jpg" : "_DESKTOP.png"
  }`

  return (
    <div className="item-necklace position-relative text-center mx-auto w-100 mb-4 mb-l-5 mb-xl-0">
      <div className="position-relative">
        <button
          className="btn-image img-container position-relative p-0 w-100"
          onClick={onSelectClick}
        >
          <img
            alt={baseProduct}
            src={finalImg}
            width="100%"
            onLoad={handleOnImageLoad}
            onError={handleOnImageLoad}
          />
        </button>
        <SwatchSet
          baseProductCode={baseProduct}
          defaultSelectedIndex={selectedVariant}
          isSlider
          productVariants={variants}
          swatchSettings={swatchSettings}
        />
      </div>
      <p className="text-black">{rawTitle}</p>
      <SelectButton
        className={selectBtnClasses}
        selected={selected}
        onSelectClick={onSelectClick}
      />
    </div>
  )
}

NecklaceChooserItem.propTypes = {
  baseProduct: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  selectedVariant: PropTypes.number.isRequired,
  swatchIndex: PropTypes.number,
  variants: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onImageLoad: PropTypes.func.isRequired,
}

export default NecklaceChooserItem
